<template>
  <OurModal v-model="isShownModal" :title="$t('title.fleaMarket.filters')" mobile-footer-reverse>
    <FilterForm v-model="form" />

    <template #footer-left>
      <OurButton :text="$t('button.apply')" @click="onClickApplyButton" />

      <OurButton :text="$t('button.close')" variant="secondary" @click="onClickCloseButton" />
    </template>

    <template #footer-right>
      <OurButton
        class="button"
        :text="$t('button.clear')"
        variant="thirdary"
        @click="onClickCleanButton"
      />
    </template>
  </OurModal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import FilterForm from "./components/FilterForm";
import filterMixin from "@/mixins/filter.mixin";

export default {
  name: "FilterModal",
  components: {
    FilterForm,
  },
  mixins: [filterMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        id: "",
        name: "",
        accessGroupId: "",
        status: "",
      },
    };
  },

  computed: {
    ...mapState("customers", ["filtersForm"]),

    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  watch: {
    isShownModal: "onChangeShownModal",
  },

  created() {
    this.setFiltersForm();
  },

  beforeDestroy() {
    this.cleanForm();
    this.SET_FILTERS_FORM(this.form);
  },

  methods: {
    ...mapMutations("customers", ["SET_FILTERS_FORM"]),

    onChangeShownModal() {
      if (this.isShownModal) {
        if (this.filtersForm) {
          this.getForm();
        }
      } else {
        this.cleanForm();
      }
    },

    getForm() {
      this.form = { ...this.filtersForm };
    },

    cleanForm() {
      this.form = {
        id: "",
        name: "",
        accessGroupId: "",
        status: "",
      };
      this.cleanQueryParam();
    },

    closeModal() {
      this.isShownModal = false;
      this.cleanForm();
    },

    onClickCloseButton() {
      this.closeModal();
    },

    onClickApplyButton() {
      this.setQueryParam();
      this.setFiltersForm();
      this.closeModal();
    },

    onClickCleanButton() {
      this.cleanForm();
    },

    setFiltersForm() {
      this.SET_FILTERS_FORM(this.form);
    },
  },
};
</script>
